/**
@format
@flow
*/

const isDev: boolean = process.env.REACT_APP_DEVELOPMENT === 'true';

type FilterSlots = {
    characterTraits: string,
    collegeOrLeague: string,
};

const DEV_SLOTS = {
  characterTraits: '60a40a935680f8792b60433d',
  collegeOrLeague: '60a40a935680f8792b604339',
};

const PROD_SLOTS = {
  characterTraits: '60a7dd90214f9087d084043a',
  collegeOrLeague: '60a7dd90214f9087d0840436',
};

const FILTER_SLOTS: FilterSlots = isDev ? DEV_SLOTS : PROD_SLOTS;

export { FILTER_SLOTS };
